import React from "react";
import TextField from "@material-ui/core/TextField";
import InputMask from "react-input-mask";

const ICMaskInput = props => (
  <InputMask {...props} maskChar={null}>
    {inputProps => (
      <TextField {...inputProps} type={props.type} className="ic-input" />
    )}
  </InputMask>
);

export default ICMaskInput;
